<template>
<div class="section section-2 py-md-5" id="vacunacion-mundial">
  <div class="container">
    <h2 class="text-center section__title-principal mb-3">
      Ranking mundial: los 20 países que más han vacunado
    </h2>
    <p class="text-center">El porcentaje expresado por Our World In Data considera las personas vacunadas con dos dosis y el total de la población de cada país.</p>
    <div class="wrapper">
      <div class="chart-bar">
        <canvas ref="chart"></canvas>
      </div>
      <div class="col-12 d-flex justify-content-start justify-content-md-end py-1">
        <p class="mb-0 text-fuente"><b>Fuente:</b> Our World in Data</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { chartDefaults } from '@/charts'
import { getVacunacionMundial } from '@/api'
export default {
  data() {
    return {
      chart: null,
      countries: '',
      vacunas: [],
      paises: [],
      inmunizados: [],
      datos: [],
      backgroundColor: []
    }
  },

  methods: {
    async createChart() {
      this.chart = new this.$chart(this.$refs.chart, {
        type: 'bar',
        data: {
            labels: this.paises,
            datasets: [{
              data: this.inmunizados,
              backgroundColor: this.backgroundColor,
            }]
        },
        options: chartDefaults.barHorizontalMundial
      })
    }
  },

  async mounted() {
    this.countries = await getVacunacionMundial()
    this.countries.sort((a, b) => (a.inmunizados - b.inmunizados))
    this.countries.forEach(element => {
        this.paises.push(element.pais)
        this.inmunizados.push(parseFloat(element.inmunizados))
        this.backgroundColor.push(element.background)
    })

    this.createChart()
  }
}
</script>